const devConfig = {
    baseUrl: 'http://localhost:8001',
    baseWsUrl: 'ws://localhost:8080'
}

const stagingConfig = {
    baseUrl: 'https://teste.apontahora.tv/backend',
    baseWsUrl: 'wss://teste.apontahora.tv/backendws/'
}

const productionConfig = {
    baseUrl: 'https://apontahora.tv/backend',
    baseWsUrl: 'wss://apontahora.tv/backendws/'
}

function buildConfig(targetConfig) {
    targetConfig.createLink = function (suffix) {
        return this.baseUrl+suffix
    }
    return targetConfig
}

if (process.env.VUE_APP_STAGING === 'staging')
    module.exports = buildConfig(stagingConfig)
else if (process.env.NODE_ENV === 'production') 
    module.exports = buildConfig(productionConfig)
else 
    module.exports = buildConfig(devConfig)